// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.clearfix:before,\n.clearfix:after {\n  display: table;\n  content: \"\";\n}\n.clearfix:after {\n  clear: both\n}\n.el-card__header {\n  padding: 12px 20px;\n}\n.body-small.dialog-mini .el-dialog__body .el-form {\n  padding-right: 0px;\n  padding-top: 0px;\n}\n\n", ""]);
// Exports
module.exports = exports;
